export const MAP_PAGE = 'map';
export const CREDENTIALS_PAGE = 'credentials';
export const PAGE_WITH_LIST = 'page_with_list';
export const TRACKING_PAGE = 'tracking';
